<template>
  <div>
    <DSHeader title="查看问卷">
      <template slot="button">
        <div>
          <a-button type="primary" @click="goBack" class="back-button">返回</a-button>
        </div>
      </template>
    </DSHeader>
    <Form :isEdit="false" :isReadonly="true" :questionnaireId="questionnaireId" />
  </div>
</template>

<script>
import Form from '../../components/Form.vue';
import DSHeader from '@/components/DSComponents/DSHeader/index.vue';
export default {
  components: { Form, DSHeader },
  data() {
    return {
      questionnaireId: ''
    };
  },
  created() {
    const questionnaireNo = this.$route.query.questionnaireNo;
    if (questionnaireNo) {
      this.questionnaireId = questionnaireNo;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
